import actions from './actions';

const {
  GET_REQUEST_BEGIN, GET_REQUEST_SUCCESS, GET_REQUEST_FAILED,
  ADD_REQUEST_BEGIN, ADD_REQUEST_SUCCESS, ADD_REQUEST_FAILED,
  UPDATE_REQUEST_BEGIN, UPDATE_REQUEST_SUCCESS, UPDATE_REQUEST_FAILED,
  DELETE_REQUEST_BEGIN, DELETE_REQUEST_SUCCESS, DELETE_REQUEST_FAILED
} = actions;

const initState = {
  requests: [],
  total: 0,
  currentPage: 1,
  pageLimit: 50,
  loading: false,
  error: null,
};

const RequestReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_REQUEST_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_REQUEST_SUCCESS:
      return {
        ...state,
        requests: data.requests,
        total: data.total || 0,
        currentPage: data.currentPage || 1,
        pageLimit: data.pageLimit || state.pageLimit,
        loading: false,
      };
    case GET_REQUEST_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_REQUEST_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_REQUEST_SUCCESS:
      return {
        ...state,
        requests: data,
        total: state.total + 1,
        loading: false,
      };
    case ADD_REQUEST_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_REQUEST_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_REQUEST_SUCCESS:
      return {
        ...state,
        requests: data,
        loading: false,
      };
    case UPDATE_REQUEST_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_REQUEST_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_REQUEST_SUCCESS:
      return {
        ...state,
        requests: data,
        total: state.total - 1,
        loading: false,
      };
    case DELETE_REQUEST_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default RequestReducer;